export default __webpack_public_path__ + "static/media/brown_rice.508dfccf.wav";